import {TFunction} from 'i18next';
import {formatDuration, intervalToDuration} from 'date-fns';
import {constructFilter} from './constructFilter';
import {AppLanguage, formatDateOptions} from '@lib/utils';

export const SECTION_ID_DURATION = 'SECTION_ID_DURATION';

export const constructHaNDurationFilter = (t: TFunction, appLanguage: AppLanguage) => {
  const formatDurationAsString = (durationInMinutes: number): string => {
    const duration = intervalToDuration({start: 0, end: durationInMinutes * 60 * 1000});
    return formatDuration(duration, {
      ...formatDateOptions(appLanguage),
    });
  };

  return constructFilter({
    sectionId: SECTION_ID_DURATION,
    sectionTitle: t('Duration'),
    type: 'singleMandatory',
    data: [
      {id: '15' as const, label: formatDurationAsString(15), value: 15},
      {id: '30' as const, label: formatDurationAsString(30), value: 30},
      {id: '45' as const, label: formatDurationAsString(45), value: 45},
      {id: '60' as const, label: formatDurationAsString(60), value: 60},
      {id: '90' as const, label: formatDurationAsString(90), value: 90},
      {id: '120' as const, label: formatDurationAsString(120), value: 120},
    ],
    defaultFilterOptions: '30',
    predicate: (_filter, _entity: any) => true,
  });
};
